module.exports = __webpack_public_path__ + "static/TubesBottles1-0a8e728bc036b34bdf0bc779028acbe9.jpg";